import { render, staticRenderFns } from "./AiChatPanel.vue?vue&type=template&id=73420068&scoped=true"
import script from "./AiChatPanel.vue?vue&type=script&lang=js"
export * from "./AiChatPanel.vue?vue&type=script&lang=js"
import style0 from "./AiChatPanel.vue?vue&type=style&index=0&id=73420068&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73420068",
  null
  
)

export default component.exports